var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_cof.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_cof.js
// module chunks = 0